module.exports = __webpack_public_path__ + "static/media/navy.b93253df.jpg";